export default __webpack_public_path__ + "static/media/Organic mobile.68515544.svg";